import React from 'react';
import WeekRow from './WeekRow.jsx';
import { toDateKey } from '../utils/date.js';
import { formatMonthLabel, weeksForMonth } from '../utils/month.js';

/**
 * One month: a handwritten heading followed by its weeks.
 *
 * Every month renders at full strength. The header already names the month you
 * are in, so fading the neighbours only made the page flicker while scrolling.
 *
 * @param {string} monthKey
 */
export default function MonthSection({ monthKey, ...rowProps }) {
  return (
    <section data-monthkey={monthKey} className="flex flex-col gap-3">
      <h2 className="flex items-center gap-3 font-hand text-2xl leading-none">
        {formatMonthLabel(monthKey)}
        <span className="h-px flex-1 bg-line" />
      </h2>

      {weeksForMonth(monthKey).map((weekStart) => (
        <WeekRow
          key={toDateKey(weekStart)}
          weekStart={weekStart}
          monthKey={monthKey}
          {...rowProps}
        />
      ))}
    </section>
  );
}
